import { useSearchParams } from "@/hooks/useSearchParams";
import { useGetCalendarEvent } from "@/queries/calendar-event.queries";

export function useEventDetailsController() {
	const params = useSearchParams();
	const id = params.get('event-id') as string;
	const calendarId = params.get('calendar-id') as string;

	const query = useGetCalendarEvent({ id, enabled: !!id });


	return {
		query,
		calendarId,
	}

}
